import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components'
import DashCards from '../Components/DashCards'
import PushCards from '../Components/PushCards';
import { Doughnut } from 'react-chartjs-2';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import apiM from '../GlobalEnv'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Add } from '@material-ui/icons';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import LiveHelpOutlinedIcon from '@material-ui/icons/LiveHelpOutlined';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import {Link} from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
  arms: {
    fontFamily: "'Rouge Script' cursive",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  armsList: {
    marginTop: "calc(100% - 2rem)"
  },
}));
 
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
   

const CONTAINER = styled.section`

position: relative;
display: grid;
grid-template-columns: 25% 75%;
overflow-x: hidden;

@media screen and (max-width: 48rem) {
    grid-template-columns: 100%;
 }

`
const BOARD = styled.section`
@media screen and (max-width: 48rem) {
    display: grid;
    grid-template-rows: 70% 60%;
    margin-top: 1.2rem;
    height: auto; 
}

@media screen and (min-width: 48rem) {
     display: grid;
    grid-template-columns: 60% 40%;
    margin-top: 1.2rem;
    height: auto;
}


article + section {
    height: inherit
     display: flex;
    flex-direction: column;
    justify-content: center;
}
& ~ h4 {
    @media screen and (max-width: 48rem) {
        margin-top: 7rem;
    }
    margin-top: 3.5rem;
    margin-left: 1.4rem;
 }
 
article {
    // box-shadow: 1px 1px 2px silver;
    h4 {
        padding: 1rem;
    }
 }
 article section {
     height: 15rem;
     overflow-y: auto;
 }
article section ol {
    @media screen and (max-width: 48rem){
         padding-left: 0rem;
         list-style-type: none;
         & li {
             width: 100%;
             padding-left: 2rem;
         }
    } 

    display: flex;
    padding-left: 3rem;
    justify-content: space-around;
    padding-top: 2.5rem;
    flex-wrap: wrap;

    & li:last-child {
        margin-right: auto;
    }

    li p {
        width: 80%;
        font-size: .9rem;
    }

    & + p {
            padding-top: 2rem;
            padding-bottom: 1rem;
            margin-left: calc(100% - 7rem);
            color: #958f8f;
            cursor: pointer;
            &:hover {
                text-decoration: underline;
            }
    }

}

`
const SIDEBAR = styled.section`
    & {
        @media screen and (max-width: 48rem) {
            display: none;
        }
    }
        
  position: relative;
  height: 100vh;

  h1 {
     width: 183px;
    height: 54px;
    left: 20px;
    top: 27px;
    font-family: 'Rouge Script';
    font-style: normal;
    font-weight: normal;
    font-size: 64px;
    line-height: 75px;
    text-align: center;
    
    color: #000000;
 }

 nav {
     margin-left: 1.5rem;
     margin-top: 4rem;
 }
 nav ul {
     list-style-type: none;
}
nav ul li {
margin-top: 1.2rem;
}
nav ul li img {
     height: 1.2rem;
 }
 nav ul li p {
    text-decoration: none;
    color: black;
    vertical-align: top;
    font-weight: 500;
    margin-left: .5rem;
    cursor: pointer;
    &:hover {
        text-decoration: underline;
        transition: .5s ease-in-out;
        opacity: .5;
    }
 }

 button {
    display: inline-block;
    background: #3D228A;
    border: none;
    box-sizing: border-box;
    border-radius: 20px;
    -webkit-transition: all .5s ease-in-out;
    transition: all .5s ease-in-out;
    font-size: 18px;
    cursor: pointer;
    text-align: center;
    padding: .5rem;
    color: white;
    width: 11rem;
    height: 48px;
    font-size: medium;
    margin-left: 1.2rem;
    margin-top: 2rem;
    outline: none;
    transition: ease-in-out .8s;


    &:hover {
        box-shadow: 0px 4px 3px 0px #776565;
        transform: translateY(-0.3rem);
        transition: ease-in-out .5s;
    }
     }
    section {
        position: absolute;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        top: 60%;
        width: 65%;
        background: #c0c0c047;
    border-radius: 2rem;
    height: 15rem;
    padding: 1rem;
    display: flex;
    flex: 1;
    overflow: hidden;
    flex-flow: column;
    justify-content: space-around;
    align-items: center;

        h2 {
        }
        p {

        }
    }
 }
`
const VIEW = styled.section`
@media screen and (max-width: 48rem) {
    overflow: scroll;
    overflow-x: hidden;

    & section.btmSec {
        display: none
    }
}
overflow: hidden;
height: 100vh;
 header{

    position: relative;

    section {
        & h3:first-of-type {
            display: none;
        }
        @media screen and (max-width: 48rem) {
            padding-right: 1rem;
            padding-left: 1rem;
            & h3:first-of-type {
                display: none;
            }
        }
        display: flex;
        width: 100%;
        justify-content: space-between;
        padding-right: 4rem;
        padding-top: 0.5rem;
        align-items: center;
        
        p {
            color: #4c4343;
            @media screen and (max-width: 48rem) {
                font-size: small;
            }
        }
    }

    article {
        @media screen and (max-width: 48rem) {
            width: calc(100% - 2rem);
            height: auto;
            left: 355px;
            margin: 1.2rem auto;
            background: rgba(93,147,218,0.19);
            border-radius: 20px;
        }
        width: calc(100% - 4rem);
        height: 8.5rem;
        left: 355px;
        margin-top: 1.2rem;
        background: rgba(93,147,218,0.19);
        border-radius: 20px;
 
 }

    article section {
        display: flex;
        flex-flow: column;
        padding: 2rem;
        h2 {
            color: #3D228A;
            font-size: 1.2rem;
        }
        p {
            @media screen and (max-width: 48rem) {
                width: 90%;
             }
        width: 551px;
        margin-top: 1rem;
        width: 60%;
        font-family: Roboto;
        font-style: normal;
        font-weight: 400;
        font-size: 13.5px;
         color: #000000;
         line-height: 1.2rem;
        }
     }

    article img {
        position: absolute;
        top: 0.5rem;
        z-index: -1;
        right: calc(100% - 58rem);
        width: 50%;
     }
}

`
const SLIDETRACK = styled.section`


`

const myKeyF = (props) => {
    return  keyframes`
    0% {
       transform: translateX(0);
      }
      100% {
        transform: translateX(calc(-250px * ${props}));
      }
    `
}
const SELECT = styled.select`
@media screen and (min-width: 48rem) {
    font-size: large
}
outline: none;
padding: 1rem;
width: 70%;
border: 1.2px #a4508b;
border-style: dashed;
 `
                
const SLIDECONTAINER = styled.section`
    & {
    background: inherit;
    box-shadow: 0 10px 20px -5px rgba(7, 3, 3, 0.125);
    height: 100px;
    margin: auto;
    overflow: hidden;
    position: relative;
    width: 960px;
   }

  &::before, &::after {
    background: linear-gradient(to right, white 0%, rgba(255, 255, 255, 0) 100%);
    content: "";
    height: 100px;
    position: absolute;
    width: 200px;
    z-index: 2;
  }
  &::after {
    right: 0;
    top: 0;
    transform: rotateZ(180deg);
  }
  &::before {
    left: 0;
    top: 0;
  }
  
  & > section {
    animation-name: ${props => myKeyF(props.num)};
    animation-timing-function: linear;
    animation-duration: ${props => (props.num * 5) + "s"};
    animation-iteration-count: infinite;
    display: flex;
    width: calc(250px * 14); 
   }
  
  &:hover > section {
    animation-play-state: paused;
    cursor: pointer;
  
  }
  & > section {
    height: 100px;
    width: 250px;
  }
`
 
 
const NEWRECO = styled.section`
display: ${props => props.showB ? "inline-block" : "none"};
background: white;
overflow: auto;
border-radius: 5px;
transition: 1s ease-in-out;
width: 100%;
 
& input {
    display: block;
    padding: .2rem;
    border-top: none;
    border-right: none;
    border-left: none;
    border-bottom: 1.3px solid #3D228A;
    outline: none;
    margin-top: .5rem;
    margin-bottom: .5rem;
}

 button {
    background: #3D228A;
    border: none;
    display: block;
    width: 90%;
    padding: .3rem;
    font-size: medium;
    margin-top: .5rem;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
    overflow: hidden;
    margin-top: 1.5rem;
    color: white;

    

    input ~ label {
        font-size: small;
    }
}
`
const NAVIGBTN = styled.button`
outline: none;
border:none;

margin-top: 80vh;
 @media screen and (max-width:48rem) {
    margin-left: 80%;
}
@media screen and (min-width:48rem) {
    margin-left: 90%;
}
`

let checkerUser = "";

if(sessionStorage.getItem("mail")) {
  checkerUser =  sessionStorage.getItem("mail")
}

 

const NewDashboard = ({budg, moneySpent, moneyReciv, getDataFromMongo, loading, sendNewDataToMongo, allFs, moneyRecivSpec, stFs, getDaily, daily, bal, myWeek, getWeekly, getMonthly, myMonth, dispatch}) => {

    //material ui

    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);
    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
      });
    
      const toggleDrawer = (anchor, open) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
          return;
        }
    
        setState({ ...state, [anchor]: open });
      };

      
    const handleChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    };

    const [opener, setOpener] = React.useState(false);
  const [scroll, setScroll] = React.useState('paper');

  const handleClickOpen = (scrollType) => () => {
    setOpener(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpener(false);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (opener) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [opener]);
  
  

        
    const[myDate,] = useState(new Date().toUTCString().substring(0, 16))
    const[userName, ] = useState('friend')   
    const[userReport, ] = useState(`You can scale and grow your finance with ease. Save more today and spend less, always remember that alone it may be a drop but together it can be an ocean.`)    
    const[budgList, setBudg] = useState([]);
    const[spentAmt, setSA] = useState('');
    const[spentOpt, setSO] = useState('');
    const[recAmt, setRA] = useState('');
    const[recPur, setRP] = useState('');
    const[spePur, setSP] = useState('');
    const[, setBT] = useState('Save');
    const[, setBSt] = useState(false);
    const[btnTR, setBTR] = useState('Save');
    const[btnStR, setBStR] = useState(false);
    const[, setShow] = useState(false);
    const[specMonRec, setSpecMR] = useState('');
    const[specMonOp, setSpecOpt] = useState('');
    const[specMonPur, setSpecPur] = useState('');
    const[, setSpecBtnSt] = useState(false);
    const[, setSpecBtnR] = useState('Save');
    const[, setStartGet] = useState(false);
    const[fsComing, setFsComing] = useState(loading[0].isLoading)
    const[fsStruc, setFsStruc] = useState(loading[0].isLoading)
    const[dailyStru, setDailStruc] = useState(loading[0].progress)
    const[dayRecords, setDayRec] = useState([])
    const[recentClick, setRClick] = useState('daily')
    const[open, setOpen] = useState(false)
    const[userApp, setUApp] = useState('')

    const handleSpentPur = ({target}) => {
        setSP(target.value)
    }
    const handleSpecOpt = ({target}) => setSpecOpt(target.value)
   
   const handleSpecPur = ({target}) => setSpecPur(target.value)
    const handleSpecMonAmt = ({target}) => setSpecMR(target.value)
    const handleSpentAmt = ({target}) => {
            setSA( Number(target.value))
    }

    const handleSpentOptions = ({target}) => {
            setSO(target.value.toString().trim())
    }
    const handleRecAmt = ({target}) => {
        setRA( Number(target.value) )
     }
    const handleRecPurp = ({target}) => {
        setRP(target.value.toString())
    }
    const handleSpentDispatch = async () => {
        if( spentAmt !== '' && spentOpt !== '' && spePur !== '' ) {
            if(window.confirm(`You are about to save a transaction of \n \n  ${spentAmt} \n \n  for the purpose of \n \n  ${spePur}`)) {

             let {type} = await moneySpent({budg: spentOpt, amt: spentAmt, purpose: spePur})
             setBSt(true)
             setBT('Saving...')
            
             try {
                if(type === 'SPENT_BUDG') {
                    // console.log(allFs.filter(s => s.updated !== false))
                    let {status} = await sendNewDataToMongo(allFs.filter(s => s.updated !== false))
                    if(status === 'successfull') {
                            setOpen(true)
                            getDaily()
                            setSA('')
                            setSP('')
                            setBT('Save')
                            setBSt(false)
                            setShow(true)
                 } 
               else throw Error
                }
                    else {
                        setOpen('err')
                        setBT('Save')
                        setBSt(false)
                    }
                } 
            catch (error) {
                alert('Unable to save, pls try again') 
                setBT('Save')
                setBSt(false) 
                setOpen('err')
                setBT('Save')
                setBSt(false)
                 }
                
            }
            else {
                return ''
            }
            
             
            }
      else return ''
    }
    const handleRecivDispatch = async () => {
        if( recPur !== '' && recAmt !== '') {
            if(window.confirm(`You are about to save a transaction of \n \n  ${recAmt} \n \n  for the purpose of \n \n  ${recPur}`)) {
           
                let {type} = await moneyReciv({purpose: recPur.trim(), amt: recAmt})
                setBStR(true)
                setBTR('Saving...')
                 try {
                    if(type === 'RECIV_BUDG') {
                        // 
                        // console.log(allFs.length)

                        if(allFs.length > 0) {

                            // console.log('status', allFs)

                             let {status} = await sendNewDataToMongo(allFs)

                            //  console.log(status)

                        if(status === 'successfull') {
                            setOpen(true)
                            // alert('transaction recorded!!! save more and get wealthier, thanks.')
                            getDaily()
                            setRP('')
                            setRA('')
                            setBTR('Save')
                            setBStR(false)
                            setShow(true)
                                                        
        } 
        else throw Error
            
            
                        }

                        else {
                            setOpen("err")
                            setBTR('Save')
                            setBStR(false)
                            setShow(true)
                        }
                    }
                }
                 catch (error) {
                     setBTR('Save')
                    setBStR(false) 
                    alert('Unable to save, pls try again') 
    
                  }
            }
            else {
                return ''
            }
           
        } 
        else return ''
    }
    const handleSpecRecDispatch = async () => {
        if(specMonPur !== '' && specMonRec !== '') {
            if(window.confirm(`You are about to save a transaction of \n \n  ${specMonRec} \n \n  for the purpose of \n \n  ${specMonPur}`)) {
            let {type} = await moneyRecivSpec({purpose: specMonPur.trim(), budg: specMonOp, amt: specMonRec  })
            setSpecBtnSt(true)
            setSpecBtnR('Saving...')

            try {
                if(type === 'SPEC_RECIV_BUDG') {
                    let {status} = await sendNewDataToMongo(allFs.filter(s => s.updated !== false))
                    if(status === 'successfull') {
                            setOpen(true)
                            getDaily()
                            setSpecMR('')
                            setSpecPur('')
                            setSpecBtnR('Save')
                            setShow(true)

                    } 
                    else throw Error
               }
               else {
                setOpen('err')
                setSpecBtnR('Save')
                setShow(true)
               }
            }
            catch(e) {
                 setSpecBtnR('Save')
                setSpecBtnSt(false) 
                setOpen('err')
                setSpecBtnR('Save')
                setShow(true)

            }
            }
        }
    }
   
    //component
    const list = (anchor) => (
        <div
          className={clsx(classes.list, {
            [classes.fullList]: anchor === 'top' || anchor === 'bottom',
          })}
          role="presentation"
          onClick={toggleDrawer(anchor, false)}
          onKeyDown={toggleDrawer(anchor, false)}
        >
          <List>

          <ListItem button>
                 
                <ListItemText primary={'Today'} />
              </ListItem>

          <ListItem button>
                 
                <ListItemText primary={'Weekly'} />
              </ListItem>

          <ListItem button>
                
                <ListItemText primary={'Monthly'} />
              </ListItem>
            
          </List>

          <Divider className={classes.armsList} />
          <List>
            <ListItem button>
                    <ListItemIcon>  <HomeOutlinedIcon />  </ListItemIcon>
                    <ListItemText primary={"Home"} />
                 </ListItem>
          <ListItem button>
                    <ListItemIcon> <LiveHelpOutlinedIcon /> </ListItemIcon>
                    <ListItemText primary={"FAQ's"} />
                 </ListItem>
              {userApp ? (

                     <ListItem button onClick={() => handleLogOut()}>
                     <ListItemIcon>   <ExitToAppOutlinedIcon /> </ListItemIcon>
                     <ListItemText primary={"Log out"} />
                   </ListItem>

              ) : (
                    <ListItem button>
                        <Link to="/iamwealthy-login">
                     <ListItemText primary={"Log in"} />
                        </Link>
                   </ListItem>
              )
              
            }
              
          </List>
        </div>
      );
   
   //API calls

        useEffect(() => {setBudg(budg)}, [budg])

    useEffect(() => {
            if(recentClick === "month") {
                setDayRec(myMonth)
            }
    }, [myMonth, recentClick])
    useEffect(() => {
            if(recentClick === "week") {
                setDayRec(myWeek)
            }
    }, [recentClick, myWeek])

    useEffect(() => {
        if(recentClick === "daily") {

            setDayRec(daily)
        }
    }, [daily, recentClick])
    useEffect(() => {
        setDailStruc(loading[0].progress)
    }, [loading])

    useEffect(() => {
        getDaily()
    },[getDaily])
       
    useEffect(() => {
        setFsComing(loading[0].isLoading);

    }, [loading])

    useEffect(() => {
        setFsStruc(stFs)

    }, [stFs])

     useEffect(() => {
            if(allFs.length < 1) {
       
            getDataFromMongo()
        }
            setStartGet('am set')
        
       },[getDataFromMongo,allFs])

   const handleLogOut = async () => {
         const api = apiM +  `/logout/${sessionStorage.getItem('mail')}`

        let res = fetch(api)

        let {log} = await (await res).json()
        
        if(log === 'failed') {
              alert('unable to log out, it seems an error occured, pls try again')
        }  
        else {
           await sessionStorage.removeItem('lStr')
         sessionStorage.removeItem('mail')
           window.location.replace('/')
          }
    }

    useEffect(() => {

        setUApp( checkerUser && checkerUser.length > 1 ? true : false)
    }, [])


    return ( 
        <>

        {/* //mobile btn dalogue goes here */}
        <NAVIGBTN style={{borderRadius:'50%', background:'#261431', color:'white', padding:'.7rem', position:'fixed', zIndex:'4', fontSize:'large',cursor:'pointer', display: "flex", justifyContent: "center", alignItems: "center"}} onClick={handleClickOpen('paper')}><Add />
        </NAVIGBTN>
        <div>
      {['right'].map((anchor) => (
        <React.Fragment key={anchor}>
           <SwipeableDrawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            onOpen={toggleDrawer(anchor, true)}
          >
            {list(anchor)}
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
        {/* dialogue box goes here */}
        <Dialog
        open={opener}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle style={{fontFamily: "cursive"}} id="scroll-dialog-title" className="dashH" >  'wealthy </DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
        <NEWRECO showB={true}>
                <h3 style={{textAlign: 'center', marginTop: '.5rem'}}>Add a new Record</h3> 
                
                {/* <span onClick={() => setShowB(false)} style={{marginLeft: '.5rem', color: '#ff0000bf', fontWeight: 'bold',
    cursor: 'pointer'}}>X</span> */}

                <div className={classes.root} style={{marginTop: "3rem"}}>
      <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className={classes.heading}>Money Recieved</Typography>
          <Typography className={classes.secondaryHeading}>Record a gain</Typography>
        </AccordionSummary>
        <AccordionDetails>
     
          <section>
                    
                    <form style={{marginLeft:'.5rem'}}>
                        <label htmlFor='amount'> Amount </label>
                        <input 
                        type='number' 
                        placeholder='just the amount e.g 200'
                        value={recAmt}
                        id='amount'
                        onChange={handleRecAmt}
                         />
              
                        <label htmlFor='from' style={{marginTop:'2rem', display:'block'}}> From </label>
                        <input 
                        as='textarea' 
                        type='text' 
                        style={{lineHeight: '1.5rem'}}
                        placeholder='how you earned the money'
                        value={recPur}
                        required={true}
                        onChange={handleRecPurp}
                         />
                    </form>
                    
                    <button onClick={handleRecivDispatch} disabled={btnStR} style={{cursor:'pointer'}} className={btnStR ?'disabled' : ''} >{btnTR}</button>
        </section>
          
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className={classes.heading}>Money Spent</Typography>
          <Typography className={classes.secondaryHeading}>
            Record an amount spent
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
        <section>
                    
                    <form style={{marginLeft:'.5rem'}}>
                        <label htmlFor='amount'> Amount </label>
                        <input 
                        type='number' 
                        placeholder='just the amount e.g 200'
                        value={spentAmt}
                        id='amount'
                        onChange={handleSpentAmt}
                        />
                        <br />
                       <br />
                       <label 
                       htmlFor='on' 
                       style={{marginTop:'2rem', display:'block'}}>
                            On what?
                       </label>

                       <SELECT  
                           id='on' 
                           required={true}
                            onChange={handleSpentOptions}>
                           <option value={'choose from list'}>{'choose from list'}</option>
                           {
                               budgList.map((list, i) => {
                                if(typeof(list) === 'object') {
                                   return <option value={'choose from list'}>{'choose from list'}</option>
                               }
                             else return <option key={i} value={`${list}`}>{`${list}`}</option>} )
                           }
                           
                           </SELECT>
                           <br />
                           <br />
                           <br />
                           <label htmlFor='amount'> Purpose </label>
              
                           <input 
                       type='text'
                       as='textarea' 
                       id='amount'
                       required={true} 
                       placeholder='what you spent the money on'
                       value={spePur}
                       onChange={handleSpentPur}
                       style={{lineHeight: '1.5rem'}}
                        />
                          
                    </form>
                    
                    <button onClick={handleSpentDispatch} disabled={btnStR} style={{cursor:'pointer'}} className={btnStR ?'disabled' : ''} >{btnTR}</button>
        </section>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography className={classes.heading}>Specific Gain</Typography>
          <Typography className={classes.secondaryHeading}>
            Record a specific budget Gain
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
        <section>
                    
                    <form style={{marginLeft:'.5rem'}}>
                        <label htmlFor='amount'> Amount </label>
                        <input 
                       type='number' 
                       id='amount' 
                       placeholder='just the amount e.g 200'
                       value={specMonRec}
                       onChange={handleSpecMonAmt}
                       required={true} />
                       <br />
                       <br />
                       <label 
                       htmlFor='on' 
                       style={{marginTop:'2rem', display:'block'}}>
                            On what?
                       </label>

                       <SELECT  
                           id='on' 
                           required={true}
                            onChange={handleSpecOpt}>
                           <option value={'choose from list'}>{'choose from list'}</option>
                           {
                               budgList.map((list, i) => {
                                if(typeof(list) === 'object') {
                                   return <option value={'choose from list'}>{'choose from list'}</option>
                               }
                             else return <option key={i} value={`${list}`}>{`${list}`}</option>} )
                           }
                           
                           </SELECT>
                            <br />
                           <br />
                           <label htmlFor='amount'> Purpose </label>
              
                           <input 
                       type='text'
                       as='textarea' 
                       id='amount'
                       required={true} 
                       placeholder='how you earned the money'
                       value={specMonPur}
                       onChange={handleSpecPur}
                       style={{lineHeight: '1.5rem'}}
                        />
                          
                    </form>
                    
                    <button onClick={handleSpecRecDispatch} disabled={btnStR} style={{cursor:'pointer'}} className={btnStR ?'disabled' : ''} >{btnTR}</button>
        </section>
        </AccordionDetails>
      </Accordion>
     
    </div>
        </NEWRECO>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          
        </DialogActions>
      </Dialog>

    <CONTAINER>


        <SIDEBAR>
            <h1 id="dashH">'wealthy</h1>

            <nav>
                <ul>
             
                  <li> 
                      <img src={require('../Assets/Images/icons.svg')} alt="today" />
                       <p  onClick={()=> getDaily()}> Today </p>
                     </li>
                  <li> 
                      <img src={require('../Assets/Images/icons.svg')} alt="Weekly" />
                       <p  onClick={()=> {getWeekly(); setRClick("week")} }> Weekly </p>
                     </li>
                  <li> 
                      <img src={require('../Assets/Images/icons.svg')} alt="Monthly" />
                       <p  onClick={() => {getMonthly(); setRClick("month")}}> Monthly </p>
                     </li>
                     </ul>
                    
            </nav>

            <button onClick={ handleClickOpen('paper')}> Add new record + </button>
            {/* <button onClick={() => setShowB(true)}> Add new record + </button> */}

                            {userApp ? (

                              <p onClick={() => handleLogOut()} style={{margiBbottom:'0', bottom: '5%',position: 'absolute',left: '2rem', cursor:"pointer"}}>Log out</p>
                            ) : (
          <p style={{margiBbottom:'0', bottom: '5%',position: 'absolute',left: '2rem', cursor:"pointer"}}>
          <Link to="/iamwealthy-login">Log in</Link>
          </p>
                            )}
            {/* <section>
                <h2>Quotes</h2>
                <p>
                    This is the best place to be, in the essense and true beauty of every man is the developement of character and the love for his job and dreams
                </p>
            </section> */}

        </SIDEBAR>


        <VIEW>
            <PushCards />



            <header>
        {/* <MobileNav />
<br />
<br /> */}
                 <section>
                    <h3 onClick={toggleDrawer('right', true)}>Dashboard</h3>
                    <h3 onClick={toggleDrawer('right', true)}>Dashboard</h3>
                    <p>{myDate}</p>
                          
                </section>

                <article>
                    <section>
                        <h2>Welcome, back {userName}! </h2>
                        <p>{userReport}</p>
                    </section>
                    <img src={require('../Assets/Images/dashImg.svg')} alt="you are welcome" />
                </article>

            </header>
            <Snackbar open={open} autoHideDuration={6000}>
        <Alert severity="success" onClose={() => setOpen(false)}>
          Record was saved successfully
        </Alert>
      </Snackbar>
            <Snackbar open={open === "err" ? true : false} onClose={() => setOpen(false)} autoHideDuration={6000}>
            <Alert severity="warning" onClose={() => setOpen(false)}>There seems's to be some error, check your network </Alert>
      </Snackbar>
 
            <BOARD>
                <article>
                    <h4 style={{color: "#3d228a"}}>{recentClick === "week" ? "This Week" : recentClick === "month" ? "This Month" : "Most recent"}</h4>

                    <section>
                        {
                        dailyStru === "progress" ? 
                                ( 
                                    <ol>
                                    <section style={{display: 'flex', justifyContent: "center", flexDirection: "column", alignItems:"center"}}>
                                     <img 
                                     style={{height: "3rem", width: "3rem"}}
                                     src={require('../Assets/Preloaders/25.gif')} 
                                     alt="you have no recent record or transaction" />
                                    <p> Pls wait while we get your records </p>
                                    </section>
    
                                </ol> 
                                 )
                                 : 
                        dailyStru === "Empty" ? 
                        (       
                            <ol>
                                <section style={{display: 'flex', justifyContent: "center", flexDirection: "column", alignItems:"center"}}>
                                 <img 
                                 style={{height: '7rem'}}
                                 src={require('../Assets/Images/5613.jpg')} alt="you have no recent record or transaction" />
                                 
                                {fsStruc.length > 0 ? (
                                    <p>
you have no recent record or transaction<br /> 

                                    </p>
                                ) : (
                                <p>
you have no recent record or transaction<br /> 
<a href="/finance"><small>setup finance </small>  </a> or 
                                <a href="/dashboard"><small> refresh </small> </a>
                                </p>
                                ) }
                                
                                 
                                </section>

                            </ol>
                        )
                                :
                        dailyStru === false ? 
                        (
                            <div>An Error Occured</div>
                        ) 
                        
                        : (
                            <ol>
                                {dayRecords.sort().map((val, i) => (
                                    <li style={ i > 1 ?  {width: "50%", marginTop: '4rem'} : {width: "50%"} }>
                                    <strong style={{fontWeight: '500'}}>{val.budg}</strong> 
                                    <p>{val.purpose}</p> 
                                   <br />
                                    <p> Bal: <strong>N {val.money.toLocaleString()} </strong> </p>

                                {val.spendBol ? <p style={{marginTop: '.3rem'}}> Spent: <strong> {val.diff} </strong>  </p> : <p style={{marginTop: '.3rem'}}> Gain: <strong> {val.diff.toLocaleString()} </strong></p>}
                                     
                                    
                                        <br />
                                     <p> <small style={{color:"#5d5c5c", fontWeight: "500"}}>{val.day} {val.month} {val.dayNo} | {val.timeTrans}</small>     </p>
        
        
                                     </li>
                                ))}
                            </ol>
                        )
                     }
                       

                        {/* <p style={dailyStru === "Empty" || dailyStru === "progress" || dailyStru === false ? {visibility: "hidden"} : {display: "inline-block"}}>View all...</p> */}

                    </section>

                </article>
                <section style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                <Doughnut
          data={{
            labels: budg,
            datasets: [
              {
                label: 'Rainfall',
                backgroundColor: [
                  '#B21F00',
                  '#C9DE00',
                  '#2FDE00',
                  '#00A6B4',
                  '#6800B4',
                  '#ee82ee',
                ],
                hoverBackgroundColor: [
                '#501800',
                '#4B5000',
                '#175000',
                '#003350',
                '#35014F',
                '#ffa500',
                ],
                data: bal
              }
            ]
          }}
          options={{
              animation: {
                duration: 7000,
              },
            title:{
              display:true,
               fontSize:20,
               animation: 10000,
            },
            legend:{
              display:true,
              position:'right'
            }
          }}
        />
                </section>
            </BOARD>

            <h4>Your Structure</h4>
 
          
           
             <section>
                 {!fsComing ? (
 
                        <SLIDECONTAINER num={fsStruc.length}>
                        <SLIDETRACK>
                        {
                        fsStruc.map((val, i) => (

                                <div className="silde">
                                    
                                    <DashCards 
                                        perc={val.rPerc}
                                        amt={val.money}
                                        budg={val.budg}
                                        iBg={i} 
                                         />
                                </div>
                            
                        )) 
                            }  
                        </SLIDETRACK>
                        </SLIDECONTAINER>


                 ) : (
                     <div style={{display: "flex", justifyContent: "center"}}>
                        <img style={{height: "3rem", width: "3rem"}} src={require('../Assets/Preloaders/25.gif')} alt="preloader" />
                     </div>

                 )}
             </section>
        

<section className="btmSec" style={{marginBottom: '4rem'}}></section>
      
        


            
        </VIEW>

        




    </CONTAINER>


        </>
     );
}
 
export default NewDashboard;